import React from "react";

export function Modal({
  isOpen,
  onClose,
  title,
  children,
  mw,
  overFlowHeight,
}) {
  if (!isOpen) return null;

  const minHClass = overFlowHeight
    ? overFlowHeight === "inherit"
      ? "min-h-inherit"
      : `min-h-[${overFlowHeight}]`
    : "";

  console.log("minHClass", minHClass);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 animate-fade-in-up animate-duration-200"
      onClick={handleOverlayClick}
    >
      <div
        className={`relative bg-white rounded-lg shadow-xl ${
          mw ? mw : "max-w-4xl"
        } w-full mx-4 max-h-[90vh] flex flex-col`}
        role="dialog"
        aria-modal="true"
      >
        {title && (
          <div className="p-6 pb-0">
            <div className="flex justify-between items-center border-b border-stroke pb-3">
              <h2 className="text-xl font-bold text-gray-900">{title}</h2>
              <button
                onClick={onClose}
                aria-label="Close modal"
                className="cursor-pointer"
                type="button"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM13.5225 6.46191C13.2296 6.16905 12.7548 6.16903 12.4619 6.46191L9.99219 8.93164L7.52246 6.46191C7.22958 6.16903 6.75481 6.16905 6.46191 6.46191C6.16903 6.75479 6.16905 7.22956 6.46191 7.52246L8.93164 9.99219L6.46289 12.4619C6.17001 12.7548 6.16998 13.2296 6.46289 13.5225C6.75581 13.8152 7.23061 13.8153 7.52344 13.5225L9.99219 11.0527L12.4609 13.5225C12.7538 13.8153 13.2286 13.8152 13.5215 13.5225C13.7962 13.2478 13.8137 12.8132 13.5732 12.5186L13.5215 12.4619L11.0518 9.99219L13.5225 7.52246C13.8153 7.22956 13.8153 6.75479 13.5225 6.46191Z"
                    fill="#141A33"
                  />
                </svg>
              </button>
            </div>
          </div>
        )}

        <div
          className={`${minHClass} my-3 overflow-y-auto py-1.5 flex-1 px-6 relative`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
